import {useApi} from "~/composables/api/utils/useApi"
import {camelCase} from 'lodash'

export const useConfigApi = () => ({
  async load() {
    //const url = `configs?filter[groups]=payments,contact,rrss`
    const url = `configs?filter[groups]=contact,rrss`
    const api = useApi()

    try {
      const response = await api.makeRequest(url, 'get')
      const prepared = {}

      response?.forEach((item) => {
        const keyCC = camelCase(item.key_name)
        prepared[keyCC] = item.key_value
      })

      return prepared
    } catch (err) {
      throw err
    }
  }
})
